module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'invoices.show',
        params: {
          id: _vm.invoice.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "invoice-status",
    class: _vm.invoice.status_class,
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.invoice.status_text
    }
  }, [_vm._v(_vm._s(_vm.invoice.status_letter))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('h2', {
    staticClass: "truncate"
  }, [_c('strong', [_vm._v("Invoice " + _vm._s(_vm.invoice.xero_number))]), _vm._v(" - " + _vm._s(_vm.invoice.user_name) + ".")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('ul', {
    staticClass: "breakdown"
  }, [_c('li', [_c('span', [_vm._v("Invoiced:")]), _vm._v(" " + _vm._s(_vm.invoice.total_with_gst))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Paid:")]), _vm._v(" " + _vm._s(_vm.invoice.paid))]), _vm._v(" "), (_vm.invoice.isNotPaid) ? _c('li', {
    staticClass: "due"
  }, [_c('span', [_vm._v("Due:")]), _vm._v(" " + _vm._s(_vm.invoice.remaining))]) : _c('li', [_c('span', {
    staticClass: "text-success"
  }, [_c('strong', [_vm._v("PAID")])])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "details"
  }, [_c('li', [_c('span', [_vm._v("Created:")]), _vm._v(" " + _vm._s(_vm.invoice.created_date))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Due:")]), _vm._v(" " + _vm._s(_vm.invoice.due_date))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Reference:")]), _vm._v(" " + _vm._s(_vm.invoice.order_reference))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-1432608e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoices/InvoiceItem.vue
// module id = 935
// module chunks = 0